<template>
  <div class="main-content">
    <el-row :gutter="40">
      <el-col :span="18" class="vright-panel">
        <resumeView :type="resumeType" :id="resumeId" :isII="isInsteadInvite" :keyword="keyword" :jobId="jobId"
          @resumeLoaded="onGetData">
        </resumeView>
      </el-col>
      <el-col :span="6">
        <assistant :resumeId="resumeId" :jobId="jobId" :type="resumeType" :isII="isInsteadInvite" @menu-click="onMenuClick"></assistant>
        <historyInsteadinvite v-if="resumeType>2" :type="resumeType" :id="resumeId"></historyInsteadinvite>
      </el-col>
    </el-row>
    <dlgInsteadInvite ref='dlgInsinv' @success="onIISuccess">
    </dlgInsteadInvite>
    <!-- <dlgChatToMe ref="dlgChat"></dlgChatToMe> -->
  </div>
</template>

<script>
  import {
    resumeType2Source
  } from '~/utils';
  import {
    getUserDataID
  } from '~/api/me';
  import resumeView from './resumeDetail/ResumeView';
  import assistant from './comp_assistant';
  import historyInsteadinvite from './comp_historyii';
  import dlgInsteadInvite from './dlg_insteadInvite';
  export default {
    components: {
      resumeView,
      assistant,
      historyInsteadinvite,
      dlgInsteadInvite,
    },
    data() {
      return {
        resumeId: parseInt(this.$route.query.id),
        resumeType: parseInt(this.$route.query.type), //1-乐跳可推荐，2-乐跳历史会员，3-乐跳游客 4-猎头候选人，5-O库人才(Ma...)，6-P1库人才(Mb...)
        jobId: 0,
        isInsteadInvite: this.$route.query.isII === 'true',
        keyword: this.$route.query.keyword,
        talent: null,
        name: '',
        userDataId: 0,
      };
    },
    created() {
      if (!this.resumeId) {
        this.$message.error('未找到简历');
      }
      if(this.$route.query.jobId){
        this.jobId = parseInt(this.$route.query.jobId);
      }
      document.title = '人才详情 - 乐跳网';
      this.getUserDataId();
    },
    methods: {
      onIISuccess() {
        this.isInsteadInvite = true;
      },
      onMenuClick(no) {
        switch (no) {
        case 1:
          break;
        case 2:
          this.goChat();
          break;
        case 3:
          this.$refs['dlgInsinv'].show(this.talent);
          break;
        case 4:
          this.goChat();
          break;
        case 5:
          break;
        }        
      },
      getUserDataId(){
        var params = {
          meDataId: this.resumeId
        };
        getUserDataID(params).then(r => {
          if (r.errcode === 0) {
            this.userDataId = r.data;
          }
        });
      },
      
      onGetData(talent) {
        this.talent = talent;
        this.name = talent.name;
        this.talent.resumeId = this.resumeId;
        this.talent.resumeSource = resumeType2Source(this.resumeType);
      },
      goChat(){
        if(this.userDataId <= 0){
          this.$message.error('未找到用户');
          return false;
        }
        this.$router.push({
          path: 'HrChat',
          query: {
            userid: this.userDataId,
            jobid: this.jobId
          }
        });
      },
    },
  };
</script>

<style>
</style>